import { Profile } from "@/models/database/profiles/profile.model";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import slugify from "react-slugify";
import { generateRandomAvatar } from "./generateRandomAvatar";
import { generateRandomUsername } from "./generateRandomUsername";

export const getRandomUserdata = {
  slug: slugify(generateRandomUsername),
  region: "Europe",
  userName: generateRandomUsername,
  uid: "",
  fullName: "",
  profileDescription: "",
  favoriteGames: [],
  lang: brand.defaultLanguage,
  profileLogoUrl: generateRandomAvatar,
  theme: brand.brandTheme,
  platform: brand.tenantId as any,
  allPlatforms: [brand.tenantId],
  profileLogoUrlHistory: [],
  country: "",
  followersCount: 0,
  friendsCount: 0,
  termsAccepted: false,
} as Profile;
